import { BookingImportJob } from '../../../types';

import { apiRequest } from './client';

// Get a booking import job by ID
export const getBookingImportJob = async (
  jobId: string,
  token: string
): Promise<BookingImportJob> => {
  return apiRequest<BookingImportJob>({
    endpoint: `/booking-import-jobs/${jobId}`,
    method: 'GET',
    token,
  });
};

// Get the booking import job for a receipt
export const getBookingImportJobByReceiptId = async (
  receiptId: string,
  token: string
): Promise<BookingImportJob> => {
  return apiRequest<BookingImportJob>({
    endpoint: `/booking-import-jobs/from-receipt/${receiptId}`,
    method: 'GET',
    token,
  });
};
